import { callApi } from "./service";

export const companyPostViewService = {
  InsertRead,
  getAll,
  getAllPost,
  DeleteReadPost,
  InsertLike,
  DeleteLikePost,
  getDateFilters,
  getByFilters,
  getById,
};

async function InsertRead(params) {
  return callApi("/backend/InsertReadPost", "POST", params).then((result) =>
    handleRsponse(result)
  );
}

async function DeleteReadPost(params) {
  return callApi("/backend/DeleteReadPost", "POST", params).then((result) =>
   handleRsponse(result)
  );
}

async function InsertLike(params) {
  return callApi("/backend/InsertLikePost", "POST", params).then((result) =>
    handleRsponse(result)
  );
}

async function DeleteLikePost(params) {
  return callApi("/backend/DeleteLikePost", "POST", params).then((result) =>
    handleRsponse(result)
  );
}

async function getAll() {
  return callApi("/backend/CompanyPostDetail", "GET").then((result) => {
    if (result.responseCode == "00") {
      return result.data;
    } else {
      alert(result.responseMessage);
      return null;
    }
  });
}

async function getAllPost(postType, dateFilter) {
  return callApi(
    "/backend/CompanyPost/" + postType + "/" + dateFilter,
    "GET"
  ).then((result) => handleRsponse(result));
}

async function getDateFilters(postType, postCategoryId) {
  let type = postType == 1 ? 0 : postType == 2 ? 1 : 0;
  return callApi(
    "/backend/CompanyPost/DateFilters/" + type + "/" + postCategoryId,
    "GET"
  ).then((result) => handleRsponse(result));
}

async function getByFilters(filterDate, postCategoryId) {
  return callApi(
    "/backend/CompanyPost/ByFilters/" + filterDate + "/" + postCategoryId,
    "GET"
  ).then((result) => handleRsponse(result));
}

async function getById(id) {
  return callApi("/backend/CompanyPost/ById/" + id, "GET").then((result) =>
    handleRsponse(result)
  );
}

function handleRsponse(result) {
  if (result.responseCode === "00") return result.data;
  else if (result.responseCode === "99"){
    return null;
  }
  else {
    alert(result.responseMessage);
    return null;
  }
}
